import { render, staticRenderFns } from "./dataAnalysisFaq.vue?vue&type=template&id=2ccdf446&scoped=true"
import script from "./dataAnalysisFaq.vue?vue&type=script&lang=js"
export * from "./dataAnalysisFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccdf446",
  null
  
)

export default component.exports